<template>
	<div class='register-component'>

		<div class='register-form-box-outer'>
			<div class='register-form-box'>

				<table>
					<tbody>
						<tr>
							<td class='label-col'>Логин</td>
							<td><input v-model='login'></td>
						</tr>
					</tbody>
				</table>

				<div class='register-btn-block'>
					<router-link to='/'>Вернуться</router-link>
					<button @click='blockUser' class='register-btn'>Удалить</button>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
	import router from '@/router';
	const REMOVE_USER = process.env.VUE_APP_ROOT_API + 'auth/block_user.php';

	import { mapState } from 'vuex';

	export default {
		name: 'BlockUserComponent',
		data: () => ({
			login: null
		}),
		computed: {
		},
		methods: {
			blockUser() {

				let isIncorrect = false;

				if (this.login === null || this.login === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести логин', life: 10000});
					isIncorrect = true;
				}
				if (isIncorrect) {
					return;
				}

				const form = new FormData();
				form.append('login', this.login);

				fetch(REMOVE_USER, {
					method: 'post',
					body: form,
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					console.log(res)
					if ( res == 0) {
						this.$toast.add({severity: 'success', detail: 'Учетная запись удалена', life: 10000});
					}
					 else {
						this.$toast.add({severity: 'error', detail: 'Учетная запись не найдена', life: 10000});
					}
					
				})
				.catch(error => {
					this.$toast.add({severity: 'error', detail: 'Произошла ошибка', life: 10000});
				});
			}
		},
		created() {
		},
	};
</script>

<style scoped>

	.register-component {
		height: 100vh;
		position: relative;
	}

	.register-form-box-outer {
		height: 100%;
		width: 560px;
		margin: auto;

		/*background-color: black;*/
		padding: 40px;

	}

	.register-form-box table {
		width: 100%;
	}

	.register-form-box {
		position: relative;
		top: 50%;
		transform: translateY(-100%);
	}

	/*.back-to-login-block {
		position: absolute;
		left: 20px;
		bottom: 20px;
	}*/

	select {
		width: 100%;
	}

	table td {
		padding-bottom: 10px;
	}

	.label-col {
		text-align: right;
		padding-right: 20px;
		font-weight: bold;
	}

	input,
	select {
		height: 2rem;
		padding: 0 0.5rem;
	}

	input,
	select,
	table,
	button,
	.register-form-box {
		font-size: 1rem;
	}

	.register-btn-block {
		margin-top: 20px;
	}

	.register-btn-block::after {
		display: table;
		content: '';
		clear: both;
	}

	.register-btn {
		float: right;
	}

</style>